import React from 'react';
import { ArrowRightIcon, CheckIcon, CreditCardIcon } from 'lucide-react';
import { afterPaymentSteps, priceIncludes } from '../data/landing';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
import { LaunchCountdown } from './LaunchCountdown';
import { PawTrail } from './PawTrail';
export function PricingSection() {
  return <section id="precio" className="relative overflow-hidden bg-cream py-14 sm:py-20" data-id="element-86" data-mp="1jai8ksrs7xqk">
      <PawTrail count={5} className="absolute left-[6%] top-14 hidden lg:flex" data-id="element-87" data-mp="1n9r1xwiwttll" />

      <div className="mx-auto max-w-2xl px-5 sm:px-8" data-id="element-88" data-mp="1s8u9poq9ydx9">
        <h2 className="text-center font-display text-3xl font-semibold leading-tight tracking-tight text-petrol sm:text-4xl" data-id="element-89" data-mp="1sbgfbitlujcu">
          Empezá hoy.
        </h2>

        <div className="mt-8 rounded-[2rem] border border-petrol/5 bg-white p-7 shadow-lift sm:p-10" data-id="element-90" data-mp="226i58gvpfpgh">
          <LaunchCountdown data-id="element-91" data-mp="2w0gaw9eae0o" />

          <div className="mt-6 text-center" data-id="element-92" data-mp="2ws079tmqnb4">
            <p className="font-sans text-xs font-bold uppercase tracking-[0.22em] text-petrol-muted" data-id="element-93" data-mp="7t0eym3x0ehr">
              Pago único
            </p>
            <p className="mt-2.5 font-display text-[3.5rem] font-semibold leading-none tracking-tight text-petrol sm:text-[4.5rem]" data-id="element-94" data-mp="1mhzl3iilkvf5">
              $19.990
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-gold-soft px-4 py-2 font-sans text-sm font-bold text-petrol-dark sm:text-base" data-id="element-95" data-mp="1crn05p6vf08h">
              <CreditCardIcon className="h-4 w-4" strokeWidth={2.3} aria-hidden="true" data-id="element-96" data-mp="25faggs13z4pb" />
              3 cuotas sin interés con Mercado Pago
            </p>
          </div>

          <ul className="mx-auto mt-7 grid max-w-sm gap-3" data-id="element-97" data-mp="20ecxwec6s8na">
            {priceIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-98" data-mp="1vj7fvqlwne4h">
                <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-sage text-white" data-id="element-99" data-mp="1rezr5tfg5y69">
                  <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-100" data-mp="k3iu32ke0l59" />
                </span>
                <span className="font-sans text-[15px] font-medium leading-snug text-petrol" data-id="element-101" data-mp="fz1b35luqbvj">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-102" data-mp="mfjmpx2a4ttz">
            <CtaButton size="lg" href={CHECKOUT_URL} className="w-full" data-id="element-103" data-mp="mei8xktvpt8k">
              Quiero empezar
              <ArrowRightIcon className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" data-id="element-104" data-mp="7ly6ynigtrsp" />
            </CtaButton>
          </div>

          <div className="mt-8 border-t border-petrol/10 pt-6" data-id="element-105" data-mp="3uw4n4pguielh">
            <p className="font-sans text-sm font-semibold text-petrol" data-id="element-106" data-mp="3uul8f3au8blt">
              ¿Qué pasa después de pagar?
            </p>
            <ol className="mt-3 space-y-2" data-id="element-107" data-mp="3kz09je12frga">
              {afterPaymentSteps.map((step, i) => <li key={step} className="flex items-start gap-2.5" data-id="element-108" data-mp="3px1rtwqo3mqp" data-mpi={i}>
                  <span className="mt-px grid h-5 w-5 shrink-0 place-items-center rounded-full bg-petrol-soft font-sans text-[11px] font-bold text-petrol" data-id="element-109" data-mp="3pv8jmd0eougl">
                    {i + 1}
                  </span>
                  <span className="font-sans text-sm leading-snug text-petrol/75" data-id="element-110" data-mp="2xb3doznuynig">{step}</span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}